/*
 *
 *  * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *  *    .       .       .       .       .       .       .       .       .       .       .       .
 *  *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *  *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *  *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *  *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *  *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *  *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *  *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *  *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *  *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *  *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *  *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *  *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *  *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *  *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *  *      ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *  *   . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *  *        .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *  *   .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *  *
 *  * Copyright FortyFix(c) 2025.
 *  * Title: Utility.ts;
 *  * Path:/Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/Progetti_Angular/src/environments/Utility/Utility.ts;
 *  * Description: ;
 *  * Author: Della Porta Giovanni Battista;
 *  * Created at: 17/11/25, 15:19;
 *  * Updated at: 17/11/25, 15:19;
 *
 */

import * as XLSX from "xlsx";
import { environment } from "../environment";
import {OggettoConfig} from "../../app/shared/_services/dynamic-crud.service";

/**
 * Copia nella clipboard una stringa formattata per essere incollata in Word / nDocx.
 *
 * @param content - Il contenuto principale. Se asHtml = true, deve essere HTML valido (es. "<p>...</p>").
 * @param asHtml - Se true prova a copiare anche la versione HTML (migliore per mantenere formattazione in Word). Default: true.
 */
export async function copyToClipboardForDocx(content: string, asHtml = true): Promise<void> {
  // Normalizziamo plain text (rimuoviamo CRLF strani) — utile per paste corrette
  const plain = content.replace(/\r\n/g, '\n').replace(/\r/g, '\n');

  // Se vogliamo inviare HTML, assicuriamoci di avere un wrapper minimale
  const html = asHtml
    ? (content.startsWith('<') ? content : `<div>${escapeHtml(content).replace(/\n/g, '<br>')}</div>`)
    : '';

  // Metodo moderno: navigator.clipboard.write con ClipboardItem (supporta text/html)
  if (asHtml && typeof navigator !== 'undefined' && 'clipboard' in navigator && (navigator.clipboard as any).write) {
    try {
      const blobPlain = new Blob([plain], { type: 'text/plain' });
      const blobHtml = new Blob([html], { type: 'text/html' });

      // @ts-ignore - ClipboardItem può non essere nel lib dom TS più vecchie
      const item = new ClipboardItem({
        'text/plain': blobPlain,
        'text/html': blobHtml,
      });

      // Scrive entrambi i formati; Word preferirà text/html se presente
      await (navigator.clipboard as any).write([item]);
      return;
    } catch (err) {
      // fallthrough al fallback
      // console.warn('ClipboardItem write failed, falling back to writeText', err);
    }
  }

  // Fallback 1: navigator.clipboard.writeText (solo testo)
  if (typeof navigator !== 'undefined' && 'clipboard' in navigator && typeof navigator.clipboard.writeText === 'function') {
    try {
      await navigator.clipboard.writeText(plain);
      return;
    } catch (err) {
      // fallthrough
      // console.warn('writeText failed, trying execCommand fallback', err);
    }
  }

  // Fallback 2: textarea + execCommand (funziona in molti browser non secure)
  try {
    const ta = document.createElement('textarea');
    ta.value = plain;
    // rendiamo invisibile ma selezionabile
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    ta.setAttribute('aria-hidden', 'true');
    document.body.appendChild(ta);
    ta.select();
    ta.setSelectionRange(0, ta.value.length);

    const ok = document.execCommand('copy');
    document.body.removeChild(ta);

    if (!ok) throw new Error('execCommand returned false');
    return;
  } catch (err) {
    throw new Error('Impossibile copiare negli appunti: nessuna API disponibile o permesso negato.');
  }
}

/** Escape molto semplice per inserire testo in HTML quando user passa asHtml=false ma vogliamo wrapper */
function escapeHtml(s: string) {
  return s.replace(/[&<>"']/g, (c) => {
    switch (c) {
      case '&': return '&amp;';
      case '<': return '&lt;';
      case '>': return '&gt;';
      case '"': return '&quot;';
      case "'": return '&#39;';
      default: return c;
    }
  });
}


 export function generateExcel(ExcelData: any[][], FileName?: string){
  const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(ExcelData );
  const workbook: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Foglio1');
  const xlsxBuffer: any = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array'
  });
  const blob = new Blob([xlsxBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const dwldLink = document.createElement("a");
  const url = URL.createObjectURL(blob);
  const isSafari = navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");

  if (isSafari) {
    dwldLink.setAttribute("target", "_blank");
  }

  dwldLink.setAttribute("href", url);
  dwldLink.setAttribute("download", FileName ?? `TemplateImportCoupon.xlsx`);
  dwldLink.style.visibility = "hidden";
  document.body.appendChild(dwldLink);
  dwldLink.click();
  document.body.removeChild(dwldLink);
}


export function  randomString(charNum: number){
  var pop = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!£$%&/()=?'^*";
  return Array.from({ length: charNum })
    .map(() => pop.charAt(Math.floor(Math.random() * pop.length)))
    .join('');

}


export async function SearchVies(piva:string, country?:string){
  return fetch(`https://vies.app-ac7.workers.dev/?country=${country ?? 'IT'}&vat=${piva}`, {
    method: 'GET',
  }).then(response => response.json());


  /*
  * $viesUrl = "https://ec.europa.eu/taxation_customs/vies/rest-api/ms/IT/vat/{$piva_clean}";
        $sedeLegaleInfo = null;

        try {
            $viesResponse = Http::timeout(15)->get($viesUrl);
            if ($viesResponse->successful()) {
                $viesData = $viesResponse->json();

                if (isset($viesData['isValid']) && $viesData['isValid'] === true) {
                    $indirizzoGrezzo = $viesData['address'] ?? '';
                    $datiStrutturati = $this->estraiDatiDaIndirizzoGrezzo($indirizzoGrezzo);

                    $sedeLegaleInfo = [
                        'partita_iva' => $piva_clean,
                        'ragione_sociale' => $viesData['name'] ?? 'N/D',
                        'indirizzo_completo' => trim(str_replace("\n", ", ", $indirizzoGrezzo), ", \n\r\t\v\0"),
                        'via_civico' => $datiStrutturati['via'],
                        'cap' => $datiStrutturati['cap'],
                        'citta' => $datiStrutturati['citta'],
                        'provincia' => $datiStrutturati['provincia'],
                        'fonte' => 'VIES (Unione Europea)'
                    ];
                }
            }
        } catch (\Exception $e) {
            return null;
        }


  * */
}

export async function getITPivaName(piva:string){
  return await getPivaName(piva, 'IT');
}

export async function getPivaName(piva:string, country:'IT'){
  if (!environment['openApiToken']){
    throw new Error('OpenApi Token non specificato');
    return {success:false, data: null, message: 'OpenApi Token non specificato'}
  }
  return await fetch(`https://company.openapi.com/${country}-name/${piva}`, {
    method: 'GET',
    headers:{
      'Authorization':`Bearer ${environment['openApiToken']}`
    }
  }).then(response => response.json());
}
export function SaveToLocalStorage(key: string, value: any){
  localStorage.setItem(key, JSON.stringify(value));
}
export function GetFromLocalStorage(key: string){
  return localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key) ?? 'null') : null;
}

